import React, { useState } from 'react';
import { IoMenu, IoPersonCircleOutline } from 'react-icons/io5';

import OptionsModal from '../AuthedOptions';
import Logo from '../Logo';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';
import { useMobileNav } from 'src/contexts/MobileNavContext';

import {
  StyledAccountMenuButton,
  StyledHeader,
  StyledHeaderLeft,
  StyledIconsWrap,
  StyledNavMenuButton,
  StyledRoleBadge,
} from './styled';

const Header: React.FC = () => {
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const { isSidebarOpen, toggleSidebar, closeSidebar } = useMobileNav();
  const { admin } = useAdminPermissions();

  return (
    <StyledHeader>
      <StyledHeaderLeft>
        <StyledNavMenuButton
          type="button"
          onClick={() => {
            setIsAccountMenuOpen(false);
            toggleSidebar();
          }}
          aria-expanded={isSidebarOpen}
          aria-label={isSidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <IoMenu size={22} aria-hidden />
        </StyledNavMenuButton>
        <Logo to="/" />
        <StyledRoleBadge title={admin?.role?.name ?? 'Admin'}>{admin?.role?.name ?? 'Admin'}</StyledRoleBadge>
      </StyledHeaderLeft>
      <StyledIconsWrap>
        <StyledAccountMenuButton
          type="button"
          onClick={() => {
            if (isSidebarOpen) closeSidebar();
            setIsAccountMenuOpen((prev) => !prev);
          }}
          aria-expanded={isAccountMenuOpen}
          aria-label="Account and settings"
        >
          <IoPersonCircleOutline size={24} aria-hidden />
        </StyledAccountMenuButton>
        {isAccountMenuOpen && <OptionsModal onClose={() => setIsAccountMenuOpen(false)} />}
      </StyledIconsWrap>
    </StyledHeader>
  );
};

export default Header;
